<template lang="pug">
  v-select.product-select(:value="selectedOption" @input="onInput" :options="options" label="name" :placeholder="loading ? 'Loading...' : placeholder" :disabled="loading || disabled")
</template>
<script>
import vSelect from 'vue-select'
import Masterdata from '@/service/apis/Masterdata'

export default {
  props: {
    value: {
      type: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      options: [],
      selectedOption: null,
      loading: false,
      placeholder: 'Select A Product'
    }
  },
  created() {
    this.loading = true
    Masterdata.listProducts({ size: 1000 }) // FIXME.. check response if there are more then 1000 products
      .then((resp) => {
        this.options = resp.data.content
        this.updateSelectedOption()
      })
      .catch((e) => { this.placeholder = e.response.data.message })
      .then(() => { this.loading = false })
  },
  methods: {
    updateSelectedOption() {
      if (this.value) {
        this.selectedOption = this.options.find((o) => o.productId === this.value)
      } else {
        this.selectedOption = null
      }
    },
    onInput(val) {
      this.$emit('input', val ? val.productId : null)
    },
    getSelectedProduct() {
      return this.selectedOption
    },
    setSelectedProduct(product) {
      const exisiting = this.options.find((o) => o.productId === product.productId)
      if (!exisiting) {
        this.options.push(product)
      }
    }
  },
  watch: {
    value() {
      this.updateSelectedOption()
    }
  },
  components: {
    vSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ssp/ProductSelect.vue